import { AccountFlagNames } from '@modules/userProfile/account/FeatureFlags';
import router from '@src/app/router';
import { useGetFeatureFlag } from '@src/app/shared/featureFlags/useGetFeatureFlag';
import authenticationStore from '@store/modules/data/authentication/authenticationIndex';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import { Ref } from '@vue/composition-api';
import modalStoreIndex from '@store/modules/ui/shared/modal/modalIndex';

export function useRegistrationInterceptor(isEarlyExit: Ref<boolean>, isRegistrationSuccessful: Ref<boolean>) {
    const modalStore = useVuexStore<typeof modalStoreIndex>('ui/modal');
    const addModalToEnd = modalStore.action('addModalToEnd');
    const closeModal = modalStore.action('closeModal');
    const authModule = useVuexStore<typeof authenticationStore>('data/authentication');
    const [isExitRegistrationModalShown] = useGetFeatureFlag<boolean>(AccountFlagNames.isExitRegistrationShown, false);

    const removeRouteInterceptor = router.beforeEach((to, from, next) => {
        const user = authModule.getter('user');
        if (user.value || isRegistrationSuccessful.value === true) {
            removeRouteInterceptor();
            next();
            return;
        }

        if (isExitRegistrationModalShown.value) {
            next(false);

            const continueNavigation = () => {
                removeRouteInterceptor();
                closeModal();
                next();
            };

            if (to.path !== from.path) {
                addModalToEnd({
                    code: modalCodes.exitRegister,
                    data: {
                        confirmLeave: continueNavigation,
                        isEarlyExit,
                    },
                });
            }
        } else {
            next();
        }
    });
}
